import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_beeinvesttech.png",
      alt: "Estratégias Bee InvestTech",
    },
    title: "Opere com a Bee Investtech",

    // String ou array de strings
    text: "Nossos robôs são desenvolvidos de forma inteligente, utilizando o que existe de melhor em recursos operacionais e tecnologia de mercado. Mantenha suas emoções no controle, gerencie seu risco e maximize seus lucros.",
    testimonial: {
      text: "Operar com a emoção é dar espaço para o risco",
      author: {
        name: "Wilson Rabelo, Co-Founder Bee Investtech",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias Bee Investtech",
    heading: "Escolha a que mais se encaixa no seu perfil.",
    subtitle:
      "Estratégias prontas, testadas e desenvolvidas por traders profissionais. Comece agora mesmo com apenas alguns cliques.",
  },

  cta: {
    title: "Pronto para lucrar com a Bee Investtech?",
    subtitle: "Ative agora mesmo nossas estratégias.",
    buttonText: "Ativar Estratégias",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Bee Investtech",
    col1: [
      "Facilitamos a vida de traders pelo mundo inteiro automatizando processos, estratégias e decisões. Acreditamos que ser lucrativo no mercado é muito mais fácil se você utilizar a automação a seu favor.",
      "Fundada em 2020, por Pai e Filho, a Bee Investtech uniu os mais de 40 anos de experiência em programação de um com a experiência de mercado do outro apresentando soluções que além de lucrativas são altamente tecnológicas.",
      "Enquanto você lia essa descrição, um de nossos robôs deu gain! 😜",
    ],
    // col2: [""],
  },

  stats: {
    title: "Tenha acesso a estratégias vencedoras",
    subtitle:
      "Aproveite toda a experiência da Bee Investtech para aumentar seus lucros.",
    data: [
      {
        value: "+5",
        description: "Anos automatizando estratégias",
      },
      {
        value: "+1k",
        description: "Traders Satisfeitos",
      },
      // {
      //   value: "+2 anos",
      //   description:
      //     "Fechando todos os meses (2020 até Jul/2022) no positivo em dólar e índice, com as operações do analista João Tonello.",
      // },
    ],
  },

  features: {
    title: "Por que utilizar os robôs da Bee Investtech?",
    subtitle: "Veja quais as principais vantagens dos robôs da Bee Investtech.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description:
          "Teste nossas estratégias e confira os resultados em sua conta.",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Não se preocupe com nada, todos ajustes e parâmetros são realizados por nós.",
      },
      {
        icon: iconsSet.lock_line,
        title: "Segurança e eficiência",
        description:
          "Tenha atendimento exclusivo para tirar suas dúvidas ou solucionar problemas.",
      },
      {
        icon: iconsSet.lightning,
        title: "Velocidade",
        description:
          "Nossos algoritmos realizam milhares de cálculos por segundo e tomam decisões muito mais rápidas e precisas do que um humano.",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe tempo",
        description:
          "Você não precisa mais ficar na frente do gráfico. Escolha suas estratégias e vá aproveitar o melhor da vida enquanto a plataforma opera para você.",
      },
      {
        icon: iconsSet.favorite,
        title: "Emocional no Controle",
        description:
          "Chega de cliques indesejados, automatizando suas operações você garante que o seu emocional se manterá no controle maximizando seus lucros.",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Bee Investtech",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
